// helpers
import { jsonDecode } from "src/base/helpers/function";
// models
import CartModel from "src/models/cart-model";
import OrderModel from "src/models/order-model";

export default class StoreHelper {
  static createCartModel(payload: any = {}) {
    try {
      let temp = {
        ...payload,
      };

      return CartModel.create(payload);
    } catch (e) {
      console.log(e);
    }
  }

  static createOrderModel(payload: any = {}) {
    try {
      let temp = {
        ...payload,
      };

      return OrderModel.create(temp);
    } catch (e) {
      console.log(e);
    }
  }
}
